var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
    wp = (typeof window !== "undefined" ? window['wpVars'] : typeof global !== "undefined" ? global['wpVars'] : null);

function LoadMore(el) {
  var t = this,
    $el = $(el);

  t.pageNumber = 1;
  t.$button = $el.find('[data-load-more-button]');
  t.$list = $el.find('[data-load-more-container]');
  t.postType = $el.data('load-more-post-type');

  t.$button.on('click', function(e) {
    e.preventDefault();
    t.loadPosts();
  });

}

LoadMore.prototype.loadPosts = function () {
  var t = this;

  t.pageNumber++;
  t.$button.prop("disabled", true);

  $.ajax({
    type: "POST",
    dataType: "json",
    url: wp.ajaxUrl,
    data: {
      pageNumber: t.pageNumber,
      action: 'more_post_ajax',
      postType: t.postType
    },
    success: function(data){

      t.$button.prop("disabled",false);
      if (! data.html) {
        alert( 'Error 1: An error occurred while getting items. Please try again or contact site administrator.' );
        return;
      }
      $(data.html).appendTo(t.$list).hide().fadeIn(300);
      if (! data.hasNextPage) {
        t.$button.hide();
      }
    },
    error : function() {
      alert( 'Error 2: An error occurred while getting items. Please try again or contact site administrator.' );
    }
  });
  return false;
}

module.exports = LoadMore;
